import mixpanel from 'mixpanel-browser'
import log from './log'
import ReactPixel from 'react-facebook-pixel'

function getToken() {
  return process.env.REACT_APP_MIXPANEL_TOKEN
}

function isEnabled() {
  const token = getToken()
  return token != null && token !== ''
}

export function init() {
  const token = getToken()
  if (!isEnabled()) {
    log.info('Mixpanel init', token)
    return
  }
  mixpanel.init(token, { 'ip': false })
}

export function updateUser(traits) {
  if (!isEnabled()) {
    log.info('Mixpanel set traits ', traits);
    return;
  }
  mixpanel.people.set(traits);
}

export function identify(uniqueId, traits) {
  if (!isEnabled()) {
    log.info('Mixpanel identify', uniqueId, traits)
    return
  }
  mixpanel.identify(uniqueId)
  if (traits) {
    // Also set mixpanel People props.
    updateUser(traits)
  }
}

export function track(event, props, callback) {
  if (!isEnabled()) {
    log.info('Mixpanel track', '|', 'event =>', event, '|', 'props =>', props)
    return
  }
  mixpanel.track(event, props, callback)
}

export function trackFB(event, data) {
  ReactPixel.trackCustom( event, data )
}

export function trackFBStandard(event, data) {
  ReactPixel.track( event, data )
}

export default {
  init,
  updateUser,
  identify,
  track,
  trackFB
}



// WEBPACK FOOTER //
// ./src/util/analytics.js